import React, {PureComponent} from 'react';

import { Button, MenuItem, ProgressBar } from '@blueprintjs/core';

export default class AccountVerificationFinish extends PureComponent {
    state = {
        counter: 5
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.startCounter()
    }

    startCounter = () => {
        var counter = 5;
        var interval = setInterval(() => {
            counter--;
            this.setState({counter})
            if (counter === 0) {
                this.setState({counter: 5})
                clearInterval(interval);
                this.props.history.push('/')
            }
        }, 1000);
    }

    render() {
        return (
            <div>
                <div className='progress-bar-container'>
                    <p style={{ position: 'absolute', right: 20, top: 0, transition: '0.2s' }}>100%</p>
                    <ProgressBar intent='primary' value={ 1 } animate={ false } stripes={ false }/>
                </div>
                <h2 className='text-align-center'>Well done!</h2>
                <p className='text-align-center'>
                    Thank you for submitting your business data. The verification process can take up to <span><strong>72 hours</strong></span>.
                    Until then, you can use Emitto with limited capabilities. Check out the details and the FAQ of
                    our <a href='https://emitto.io/know-your-customer-policy' target='_blank'>Emitto Know Your Customer Policy</a>.
                    You will be automatically redirected to home page in {this.state.counter}s.
                </p>

                <div className='display-flex justify-content-center margin-top-20'>
                    <img style={{height: 200}} src="/img/emptyStates/buying_phone_numbers_alphanumeric.gif"/>
                </div>

                <div className='bottom-with-buttons center'>
                    <button onClick={()=>this.props.history.push('/')} className='btn-green'>Continue to Emitto</button>
                </div>
            </div>
        )
    }
}
